import { render, staticRenderFns } from "./CustodyExpenseBtns.vue?vue&type=template&id=3cf6e8bd&"
import script from "./CustodyExpenseBtns.vue?vue&type=script&lang=js&"
export * from "./CustodyExpenseBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports